<template>
  <div class="page-content wish_bets_pages">
    <div v-if="wishBetAuthorizationToken">
      <div v-if="!savedBetsLoaded || deleteBetInProgress">
        <dots-loader></dots-loader>
      </div>
      <div v-if="savedBetsLoaded && !deleteBetInProgress">
        <h1 v-if="!showPageTitleInHeader || (showPageTitleInHeader && tabletAndAbove)">{{ $t('PageTitle.savedbets' )}}</h1>
        <div v-if="!wishBetStoredBets.length" class="wishBetStoredBets">
          <h3 class="no_saved_bets">{{ $t('WishBets.SavedBets')}}</h3>
        </div>
        <div v-if="wishBetStoredBets.length > 0" class="wishBetStoredBets">
          <div v-for="(wishBet, index) in wishBetStoredBets" :set="[isBetSGPV=isBetSGP(wishBet), isBetSGPPlusV=isBetSGPPlus(wishBet)]">
            <div class="saved_bet">
              <div class="saved_bet_header">
                <span v-if="!isBetSGPV && !isBetSGPPlusV" class="bet_type_name">
                  <span v-if="wishBet.BetTypeExt">{{wishBet.BetTypeExt}}</span>
                  <span v-else>{{wishBet.betTypeName}}</span>
                </span>
                <span v-if="isBetSGPV" class="bet_type_name">
                  <span v-html="$t('BetSlip.tab.title.SGP.'+isBetSGPV, {legs:wishBet.betLegs.length})"></span>
                </span>
                <span v-if="isBetSGPPlusV" class="bet_type_name">
                  <span v-html="$t('BetSlip.tab.title.SGP.Plus', {legs:wishBet.betLegs.length})"></span>
                  <span class="sgpplusparticipants"> {{sgpPlusParticipants(wishBet)}} </span>
                </span>
                <span class="delete_bet" @click="deleteWishBet(wishBet)"><v-icon>close</v-icon></span>
              </div>
              <div class="saved_bet_leg" v-for="(leg, legIndex) in wishBet.betLegs">
                <div v-if="leg.idfosporttype" class="betsporticon"><icon :name="`icon-${ (leg.idfosporttype.split(' ').join('').toLowerCase()) || 'empty' }`"></icon></div>
                <div class="leg_details">
                  <div class="leg_eventname">
                    {{leg.eventName}}
                  </div>
                  <div class="leg_selectionName">{{leg.selectionName}}
                    <span>{{leg | formattedHcp}}</span>
                  </div>
                  <div class="leg_marketname">{{leg.marketName}}</div>
                </div>
                <div class="leg_info_right">
                  <div v-if="leg.PriceUp && leg.PriceDown && !sgpPriceTypes.includes(leg.IDFOPriceType && (leg.IDFOPriceType.toUpperCase() || ''))" class="leg_price">
                    <span>{{leg | formatLegOdds}}</span>
                  </div>
                  <div class="legliveicon" v-if="liveEvents.filter(ev => ev.idfoevent === leg.IDFOEvent).length > 0"> LIVE</div>
                </div>
              </div>
              <div class="saved_bet_results">
                <div class="betodds">
                  <span class="hint">{{ $t('WishBet.OddsPrice') }}</span>
                  <div v-if="wishBet.totalPrice && wishBet.totalPrice !== 0" class="value">{{wishBet | formatOdds}}</div>
                  <div v-else class="value">-</div>
                </div>
                <div class="betstake">
                  <span class="hint">{{ $t('WishBet.BetAmount')}}</span>
                  <div class="value">
                    <span v-if="wishBet.totalStake">{{wishBet.totalStake | currency}}</span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="betreturn">
                  <span>{{ $t('WishBet.MaxWin')}}</span>
                  <div class="value">
                    <span v-if="((wishBet.winStake * wishBet.totalPrice) - wishBet.totalStake)">
                      {{ ((wishBet.winStake * wishBet.totalPrice) - wishBet.totalStake) | currency }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
              <div class="saved_bet_actions">
                <v-btn @click="generateBarCode(wishBet.placementToken)" class="generate_qrcode">{{ $t('WishBet.GenerateBarcode')}}</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'
  import dotsLoader from '@/components/common/DotsLoader'
  import Icon from '@/components/common/Icon'
  import priceFormat from '@/library/priceFormat'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import hcpFormat from '@/library/hcpFormat'

  export default {
    name: 'SavedBetsPage',

    mixins: [
      Screen,
      BettingOffer
    ],

    components: {
      dotsLoader,
      Icon
    },

    computed: {
      showPageTitleInHeader () {
        return window.ctsautoconf.PAGE_TITLE_IN_HEADER_ON_MOBILE || false
      },
      wishBetAuthorizationToken () {
        return store.getters['wishBets/wishBetAuthorizationToken']
      },
      wishBetStoredBets () {
        return store.getters['wishBets/wishBetStoredBets']
      },
      savedBetsLoaded () {
        return store.getters['wishBets/getSavedBetsLoaded']
      },
      deleteBetInProgress () {
        return store.getters['wishBets/getDeleteBetInProgress']
      },
      sgpPriceTypes () {
        return store.getters['sbBetslipState/sgpPriceTypes']
      }
    },
    filters: {
      formatOdds (node) {
        let abtnr = {
          PotentialReturn: node.totalPrice,
          UnitCount: node.unitCount
        }
        return priceFormat.formatBetTypePrice(abtnr)
      },
      formatLegOdds (selection) {
        return priceFormat.formatSelectionPrice(selection)
      },
      formattedHcp (leg) {
        return hcpFormat.formatHandicap(leg)
      }
    },
    methods: {
      getWishBets () {
        // console.log('getWishBets')
        store.dispatch('wishBets/getWishBets')
      },
      deleteWishBet (wishBet) {
        store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'confirmation_popup', content: wishBet })
      },
      generateBarCode (code) {
        store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'barcode', content: code })
      },
      isBetSGP (bet) {
        let sgpPriceTypes = this.sgpPriceTypes
        let isParlay = bet && bet.betLegs && bet.betLegs.length > 1 && bet.idFoBetType && (bet.idFoBetType === 'A' || bet.idFoBetType.indexOf('A-') === 0)
        let priceType = isParlay && bet.betLegs[0].IDFOPriceType
        let eventId = isParlay && bet.betLegs[0].IDFOEvent
        let isSGP = eventId && priceType && sgpPriceTypes.includes(priceType) &&
          bet.betLegs.every(e => e.IDFOEvent === eventId && e.IDFOPriceType === priceType) && priceType
        return isSGP
      },
      isBetSGPPlus (bet) {
        let sgpPriceTypes = this.sgpPriceTypes
        let isParlay = bet && bet.betLegs && bet.betLegs.length > 1 && bet.idFoBetType && (bet.idFoBetType === 'A' || bet.idFoBetType.indexOf('A-') === 0)
        let hasSGM = isParlay && bet.betLegs.some(e => sgpPriceTypes.includes(e.IDFOPriceType))
        let tags = hasSGM && bet.betLegs.map(l => l.SystemTag)
        tags = tags || []
        let tagsCount = {}
        for (let tag of tags) {
          if (tag) {
            tagsCount[tag] = tagsCount[tag] || 0
            tagsCount[tag]++
          }
        }
        let tagsCountArr = Object.values(tagsCount)
        let maxCount = Math.max(...tagsCountArr)
        tags = [...new Set(tags)]
        let isBetSGPPlus = hasSGM && tags.length > 1 && maxCount > 1
        return isBetSGPPlus
      },
      sgpPlusParticipants (bet) {
        let tags = bet && bet.betLegs && bet.betLegs.map(l => l.SystemTag)
        tags = tags || []
        let fosNo = tags.filter(t => !t).length
        let sgpNo = [...new Set(tags.filter(t => t))].length
        let label = this.$t('Statement.SGP_PARLAY.participants' +
          (sgpNo ? '.sgm' : '') + (sgpNo > 1 ? 's' : '') +
          (fosNo ? '.fos' : '') + (fosNo > 1 ? 's' : ''),
          {sgp: sgpNo, fos: fosNo})
        return label
      }
    },
    mounted () {
      this.getWishBets()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.saved_bet
  border solid 1px #003764
  margin 0 0 5px 0
  font-size 14px
  .saved_bet_header
    border-bottom solid 1px #003764
    padding 10px
    display flex
    justify-content: space-between
    background #003764
    color #fff
    font-family 'Open Sans Bold'
    .sgpplusparticipants
      font-family 'Open Sans Regular'
      font-size 12px
      display block
  .delete_bet
    .v-icon
      color transparent
      background-image url('~@/assets/images/brands/generic/bin_icon_white.svg')
      width: 15px !important
      height: 17px !important
  .betsporticon
    display flex
    align-items center
  .leg_price
    font-family 'Open Sans Bold'
  .leg_marketname
    text-transform uppercase
    font-size 12px
  .leg_eventname
    display flex
    align-items: center
    font-family 'Open Sans SemiBold'
    .legliveicon
      margin-left 5px
  .saved_bet_actions
  .saved_bet_results
  .saved_bet_leg
    padding 10px
  .saved_bet_leg
    display flex
    justify-content: space-between
    border-bottom solid 1px #003764
    .leg_details
      margin-right auto
  .saved_bet_results
    display flex
    justify-content: space-between
    .betstake
    .betodds
    .betreturn
      flex 1 1 auto
      margin 2px
      border-radius 3px
      padding 5px
      font-family 'Open Sans SemiBold'
      text-align center
      .hint
        text-transform uppercase
    .betstake
    .betodds
      background #f2f2f2
      color #003764
    .betreturn
      background #ff671f
      color #003764
  .saved_bet_actions
    text-align center
    border-top solid 1px #003764
    >>>.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat)
      &.generate_qrcode
        width 100%
        margin auto
        color #fff
        background #003764
        background-color #003764

.no_saved_bets
  padding-top 40px
  padding-bottom 40px
  background transparent
  display flex
  justify-content: center
  height 100%
  font-size 18px
.saved_bet_leg
  .legliveicon
    margin 10px 1px 1px 1px
</style>



// WEBPACK FOOTER //
// src/components/pages/WishBet/SavedBetsPage.vue